import types from "../actionTypes";
import salesforceService from "../../services/salesforce.service";

export const getSalesforceToken =
  ({ baseUrl, code, clientId, clientSecret }) =>
  (dispatch) => {
    dispatch({
      type: types.SALESFORCE_TOKEN_REQUEST
    });

    return salesforceService
      .getOAuthToken({
        baseUrl,
        code,
        clientId,
        clientSecret
      })
      .then((payload) => {
        dispatch({
          type: types.SALESFORCE_TOKEN_SUCCESS,
          payload
        });
      })
      .catch((error) => {
        dispatch({
          type: types.SALESFORCE_TOKEN_FAILURE,
          error
        });
      });
  };
